<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <form #tmefConfigForm="ngForm">
    <div class="fluid-container">
      <div class="form-group mt-3">
        <label>File Name*</label>
        <input class="form-control" type="text" name="filename" [(ngModel)]="rowData.FILE_NAME" required>
        @if (tmefConfigForm.form?.get('filename')?.invalid && tmefConfigForm.form?.get('filename')?.touched) {
<span class="form-error-container">
          File name is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Name*</label>
        <input class="form-control" type="text" name="element" [(ngModel)]="rowData.NAME" required>
        @if (tmefConfigForm.form?.get('element')?.invalid && tmefConfigForm.form?.get('element')?.touched) {
<span class="form-error-container">
          Name is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Value*</label>
        <input class="form-control" type="text" name="value" [(ngModel)]="rowData.VALUE" required>
        @if (tmefConfigForm.form?.get('value')?.invalid && tmefConfigForm.form?.get('value')?.touched) {
<span class="form-error-container">
          Value is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Category</label>
        <input class="form-control" type="text" name="category" [(ngModel)]="rowData.CATEGORY">
      </div>
    </div>
  </form>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="saving" (click)="save()">
    @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
